import MarkingList from "../pengecekan-form/MarkingList";

const EditorMarkingRow = ({
  titleName,
  labelGrup,
  listProblemData,
  isBerangkat,
  showBerangkat,
  permittedToEdit,
  loading,
  pengecekanBerangkatData,
  pengecekanKembaliData,
  pengecekanBerangkatDetilData,
  pengecekanKembaliDetilData,
  setPengecekanBerangkatDetilData,
  setPengecekanKembaliDetilData,
  handleOnClickReload,
  handleOnClickCameraPreview,
  handleOnClickAddMarking,
  handleOnChangeKordinat,
  handleOnClickRemoveMarking,
  handleOnClickSaveMarkingList,
  folderName,
  saveDisabled,
  headerData,
}) => {
  // one photo card: "PERGI" (type berangkat) or "PULANG" (type kembali)
  const renderMarkingList = ({ type, titleSuffix, disabled }) => (
    <div className="elevated-card-tight-vertical col-start-center !px-3 !py-3 grow lg:max-w-[32rem]">
      <MarkingList
        listProblemData={listProblemData.filter(
          (el) => el.label_grup === labelGrup
        )}
        title={`${titleName} - ${titleSuffix}`}
        field={labelGrup}
        labelGrup={labelGrup}
        type={type}
        loading={loading}
        disabled={disabled}
        pengecekanBerangkatData={pengecekanBerangkatData}
        pengecekanKembaliData={pengecekanKembaliData}
        pengecekanBerangkatDetilData={pengecekanBerangkatDetilData}
        pengecekanKembaliDetilData={pengecekanKembaliDetilData}
        setPengecekanBerangkatDetilData={setPengecekanBerangkatDetilData}
        setPengecekanKembaliDetilData={setPengecekanKembaliDetilData}
        onClickReload={handleOnClickReload}
        onClickCamera={(field) => handleOnClickCameraPreview(field, type)}
        onClickAddMarking={(field, type) =>
          handleOnClickAddMarking({ field, type })
        }
        onChangeKordinat={(type, id, marking_kordinat) => {
          handleOnChangeKordinat({
            type,
            id,
            marking_kordinat,
          });
        }}
        onClickRemove={(data) => {
          handleOnClickRemoveMarking({
            data,
            type,
          });
        }}
        onClickSave={(type, labelGrup, pengecekanDetilData) => {
          handleOnClickSaveMarkingList({
            type,
            labelGrup,
            pengecekanDetilData,
          });
        }}
        folderName={folderName}
        saveDisabled={saveDisabled}
        headerData={headerData}
      />
    </div>
  );

  return (
    <div className="row-start-start w-full flex-wrap gap-4">
      {(isBerangkat || showBerangkat) &&
        renderMarkingList({
          type: "berangkat",
          titleSuffix: "PERGI",
          disabled: !isBerangkat || !permittedToEdit,
        })}
      {!isBerangkat &&
        renderMarkingList({
          type: "kembali",
          titleSuffix: "PULANG",
          disabled: !permittedToEdit,
        })}
    </div>
  );
};

export default EditorMarkingRow;
